import { useEffect } from 'react';

export const ScrollToTopOnMount = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};
export const ScrollToBottomOnMount = () => {
  useEffect(() => {
    window.scrollTo(100, 100);
  }, []);
};
